var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "block",
    { staticStyle: { "padding-bottom": "60px" } },
    [
      _c("template", { slot: "header" }, [_vm._v("Finalizar Alerta:")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "body" },
        [
          _c("div", { staticClass: "alert-details" }, [
            _c("h4", { staticClass: "section-title" }, [
              _vm._v("Agregar comentario para la finalización")
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.finishComment,
                  expression: "finishComment"
                }
              ],
              attrs: { placeholder: "Especificar detalles..." },
              domProps: { value: _vm.finishComment },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.finishComment = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("derivation-list", {
            attrs: { derivations: _vm.derivations },
            on: {
              "update:derivations": function($event) {
                _vm.derivations = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary finish",
            class: { "is-loading": _vm.loading },
            attrs: { disabled: _vm.loading },
            on: { click: _vm.submit }
          },
          [_vm._v("\n      Finalizar Alerta\n    ")]
        ),
        _vm._v("\n     \n    "),
        _c(
          "button",
          {
            staticClass: "button is-primary is-outlined cancel",
            attrs: { disabled: _vm.loading },
            on: { click: _vm.cancel }
          },
          [_vm._v("\n      Cancelar\n    ")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }